<template>
    <div class="submitWrapper paddBottom">
        <IndexHeaderOthers ref="indexHeader"></IndexHeaderOthers>
        <div class="main">
            <div class="conner">
                <div class="listData">
                    <el-descriptions class="margin-top" :column="1" size="small" border>
                        <el-descriptions-item v-for="(item, index) in ListData" :key="index">
                            <template slot="label">
                                {{ item.label }}
                            </template>
                            <div v-if="item.label == 'ATTACHHMENT:'" class="ATTACHHMENT">
                                <span class="wenjian"></span>
                                <span> {{ item.value }}</span>
                            </div>
                            <div v-if="item.label === 'LIGHTCURVE:'">
                                <div v-for="(image, ind) in item.imgList" :key="ind" class="image-row">
                                    <div v-if="image.checkList === 'Picture'">
                                        <el-image
                                                :src="image.url"
                                                :alt="image.caption"
                                                :preview-src-list="['' + image.url]"
                                                class="image-element"
                                        ></el-image>
                                    </div>
                                    <div v-else class="url-span">
                                      <span v-if="image.checkList=='Picture URL'">URL:<a :href="image.url" style="text-decoration: none;color: black;">{{ image.url }}</a> </span>
                                      <span v-else>URL:{{ image.url }}</span>
                                    </div>
                                    <span class="caption-span">caption: {{ image.caption }}</span>
                                </div>
                            </div>
                            <div v-if="item.label == 'COMMENTS:'" class="COMMENTS">
                                <div v-html="item.value"></div>
                            </div>
                            <div v-if="item.label != 'ATTACHHMENT:' && item.label != 'COMMENTS:' && item.label != 'LIGHTCURVE:'">
                                <div>{{ item.value }}</div>
                            </div>
                        </el-descriptions-item>
                    </el-descriptions>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import IndexHeaderOthers from "../../components/header/indexHeaderOthers.vue";

    export default {
        name: "customizeIndex",
        components: {IndexHeaderOthers},
        data() {
            return {
                ListData: [
                    {
                        label: "TITLE:",
                        value: "GCN/GECAM NOTICE",
                    },
                    {
                        label: "OBJECT_CLASS:",
                        value: "GRB",
                    },
                    {
                        label: "OBJECT_NAME:",
                        value: "ABCDEFG ",
                    },
                    {
                        label: "TELESCOPE:",
                        value: "ABCDEFG",
                    },
                    {
                        label: "TRIGGER_TIME:",
                        value: "2022-02-21  12:20:31.543",
                    },
                    {
                        label: "RA:",
                        value: "ABCDEFG",
                    },
                    {
                        label: "DEC:",
                        value: "ABCDEFG",
                    },
                    {
                        label: "ERROR:",
                        value: "ABCDEFG",
                    },
                    // {
                    //   label: "EMAIL:",
                    //   value: "ABCDEFG@163.com",
                    // },
                    {
                        label: "LIGHTCURVE:",
                        imgList: [],
                    },
                    {
                        label: "COMMENTS:",
                        value:
                            "",
                    },
                    // {
                    //   label: "ATTACHHMENT:",
                    //   value: "template attachment.xlsx",
                    // },
                ],
                id: this.$route.query.id,
            };
        },
        methods: {
            goBig(img) {

            },
            //Circular详情列表
            getCustomizequeryById() {
                const param = {id: this.id};
                this.$fetchGet("/cms-middle/astronCustomize/queryById", param).then((res) => {
                    this.ListData[0].value = res.astronCustomize.title;
                    this.ListData[1].value = res.astronCustomize.objectClass;
                    this.ListData[2].value = res.astronCustomize.objectName;
                    this.ListData[3].value = res.astronCustomize.telescope;
                    this.ListData[4].value = res.astronCustomize.triggerTime;
                    this.ListData[5].value = res.astronCustomize.ra;
                    this.ListData[6].value = res.astronCustomize.declination;
                    this.ListData[7].value = res.astronCustomize.positioningError;
                    this.ListData[8].imgList = JSON.parse(res.astronCustomize.lcUrl);
                    this.ListData[9].value = res.astronCustomize.comments;
                });
            },
        },
        created() {
            this.getCustomizequeryById();
        },
        mounted() {
            // window.addEventListener("scroll", this.$refs.indexHeader.scrollToTop, true);
        },
    };
</script>
<style scoped>
    .main {
        position: relative;
        margin-top: -70px;
        z-index: 99;
        width: 100%;
        height: auto;
        background: #fff;
        border-radius: 0 120px 0 0;
    }

    .conner {
        width: 1050px;
        margin: 0 auto;
        text-align: left;
    }

    .listData {
        padding-top: 30px;
        margin-bottom: 44px;
    }

    .wenjian {
        width: 21px;
        height: 18px;
        background: url(../../assets/slices_slices/atta.png) no-repeat center center;
        background-size: 100% 100%;
        display: inline-block;
        margin-right: 8px;
    }

    .ATTACHHMENT {
        color: #168ec7;
        display: flex;
        align-items: center;
    }

    .COMMENTS {
        display: flex;
        align-items: center
    }

    .image-row {
        display: flex;
        align-items: center; /* 垂直居中对齐 */
        margin-bottom: 10px; /* 每个循环内容之间的间距 */
    }

    .image-element {
        width: 100px;
        height: 100px;
        margin-right: 10px; /* 图片与其他元素的间距 */
    }

    .url-span, .caption-span {
        margin-right: 10px; /* 文本元素之间的间距 */
    }

</style>
<style>
    .el-descriptions__table th {
        width: 150px !important;
    }
</style>